<template>
  <Layout v-bind:enable_tagsview.sync="enable_tagsview" active="1">
    <TagsView v-show="enable_tagsview"></TagsView>
    <el-scrollbar id="layoutscroll" :style="{height:(this.screenHeight-48-(enable_tagsview?34:0))+'px'}">
      <div style="margin:10px 20px 0px 10px;">
          <router-view></router-view>
      </div>
    </el-scrollbar>
    <!-- <router-view></router-view>  -->
    <!-- 左侧菜单 -->
    <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{height:(this.screenHeight-88)+'px'}" slot="ref_content">
      <tree-menu :data="menu" :collapse="collapse"></tree-menu>
    </el-scrollbar>

    <!-- 顶部菜单区域 -->
    <template v-slot:ref_header>
      <Breadcrumb class="hidden-md-and-down"></Breadcrumb>
    </template>
    <div v-show="isUseAIRobot && robotVisible" style="position: fixed; cursor: pointer; bottom: 20px; z-index: 1040; right: 30px; width: 50px; height: 50px;" @click="showRobotDetail"><img style="width:100%" src="static/img/AIRobot.png" /></div>
    <div v-show="robotDetailVisible" class="robotDetail" :style="{ 'width' : robotDetailWidth, 'height': '95%' }">
        <iframe style="width: 100%; height: 100%;" :src="robotSrc"></iframe>
    </div>
  </Layout>
</template>
<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import Breadcrumb from '@/common/Breadcrumb.vue'
function switchToTree(root, menus) {
    return _.orderBy(root, `display_order`).map((r) => {
        let children = _.filter(menus, { parent_id: r.id })
        let parent = _.filter(menus, { id: r.parent_id })
        if (!_.startsWith(r.url, `/`)) {
            r.url = (parent && parent[0] && parent[0].url) + `/` + r.url
        }
        return {
            index: r.index,
            route: { path: `${r.url}` },
            label: r.name,
            icon: r.icon,
            path: r.url,
            permission: `default`,
            children: children.length > 0 ? switchToTree(children, menus) : []
        }
    })
}
export default {
    name: `Index`,
    components: {
        Layout: () => import(`./Layout/Index.vue`),
        TagsView: () => import(`@/common/TagsView.vue`),
        Breadcrumb,
        draggable
    },
    props: {
    },
    data() {
        return {
            enable_tagsview: true,
            robotVisible: true,
            robotDetailVisible: false,
            isUseAIRobot: this.$root.IsUseAIRobot == `1`,
            robotSrcConfig: this.$root.AIRobotSrc || ``,
            robotSrc: ``,
            robotDetailWidth: `300px`
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `layout/collapse`, `workbar`, `currentUser`]),
        collapse() {
            return this[`layout/collapse`]
        },
        menu() {
            let workbarid = this.$route.meta.workbar
            let wf = _.find(this.workbar, { id: workbarid })
            if (!(wf && wf.menu_models)) return []
            let allid = wf.menu_models.map(ar => ar.id)
            let root = _.filter(wf.menu_models, function(r) {
                return _.indexOf(allid, r.parent_id) == -1
            })
            let r = switchToTree(root, wf.menu_models)
            return r.length == 0 ? [] : r.length > 1 ? r : r[0].children
        }
    },
    mounted() {
        let that = this
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            that.robotSrc = that.robotSrcConfig.replace(`@UserName`, this.currentUser.username)
        })
        window.addEventListener(`message`, function(event) {
            // 处理消息
            console.log(`Received message:`, event.data)
            var data = event.data
            switch (data.key) {
            case `Close`: {
                that.robotDetailVisible = false
                that.robotVisible = true
                that.robotDetailWidth = `300px`
                break
            }
            case `FullScreen`: {
                if (that.robotDetailWidth == `300px`) {
                    that.robotDetailWidth = `90%`
                } else {
                    that.robotDetailWidth = `300px`
                }
                break
            }
            case `ExitFullScreen`: {
                that.robotVisible = false
                that.robotDetailWidth = `300px`
                break
            }
            default:
                break
            }
        })
    },
    methods: {
        getShortcut(str) {
            return this.collapse ? str.substr(0, 2) : str
        },
        showRobotDetail() {
            this.robotVisible = false
            this.robotDetailVisible = true
        }
    }
}
</script>
<style>
.robotDetail {
    position: fixed;
    cursor: pointer;
    top: 10px;
    z-index: 1040;
    right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue